import { MessageActionsType, MobileStorageKeys } from "./messageActions.types";

// action values are always sent as camelCase string
export const MessageActions = {
  acknowledge: () => ({
    action: "acknowledge",
  }),

  rating: () => ({
    action: "rating",
  }),

  landing: (isLanding: boolean) => ({
    action: "landing",
    params: {
      isLanding,
    },
  }),

  staticTitle: ({
    title,
    isEnabled,
  }: {
    title: string;
    isEnabled: boolean;
  }) => ({
    action: "staticTitle",
    params: {
      title,
      isEnabled,
    },
  }),

  dosClinic: ({
    serviceTypes = ["ALL"],
    clinicTypes = [],
    postalCode,
  }: {
    serviceTypes?: string[];
    clinicTypes?: string[];
    postalCode: string;
  }) => ({
    action: "directory",
    params: {
      category: "CLINICS",
      serviceTypes,
      clinicTypes,
      postalCode,
    },
  }),

  dosDining: ({
    types = [],
    postalCode,
  }: {
    types?: string[];
    postalCode: string;
  }) => ({
    action: "directory",
    params: {
      category: "DINING_PLACES",
      types,
      postalCode,
    },
  }),

  back: (state: "ENABLED" | "DISABLED" | "HIDDEN") => ({
    action: "back",
    params: {
      state,
    },
  }),

  // Used for storing states into mobile
  mobileStoreSet: <Key extends keyof MobileStorageKeys>({
    key,
    value,
  }: {
    key: Key;
    value: MobileStorageKeys[Key];
  }) => ({
    action: "mobileStoreSet",
    params: { key, value },
  }),

  // Used to retrieve states from mobile. Mobile will respond with mobileStoreGetResult action. If key does not exist, mobile will return empty string.
  mobileStoreGet: ({ key }: { key: keyof MobileStorageKeys }) => ({
    action: "mobileStoreGet",
    params: { key },
  }),
} satisfies MessageActionsType;
